import api from "./api";

export interface Vendor {
  _id?: string;
  name: string;
  address: string;
  city: string;
  state: string;
  zipCode: string;
  country: string;
  phoneNumber: string;
  email?: string;
  taxId?: string;
  notes?: string;
  active?: boolean;
}

export const vendorService = {
  getAllVendors: async (): Promise<Vendor[]> => {
    const response = await api.get("/vendors");
    return response.data;
  },

  getVendorById: async (id: string): Promise<Vendor> => {
    const response = await api.get(`/vendors/${id}`);
    return response.data;
  },

  createVendor: async (vendor: Vendor): Promise<Vendor> => {
    const response = await api.post("/vendors", vendor);
    return response.data;
  },

  updateVendor: async (id: string, vendor: Vendor): Promise<Vendor> => {
    const response = await api.put(`/vendors/${id}`, vendor);
    return response.data;
  },

  deleteVendor: async (id: string): Promise<void> => {
    await api.delete(`/vendors/${id}`);
  },

  downloadTemplate: async (): Promise<void> => {
    const response = await api.get("/vendors/template/download", {
      responseType: "blob",
    });

    // Create blob link to download
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'vendors_template.csv');

    // Append to html link element page
    document.body.appendChild(link);

    // Start download
    link.click();

    // Clean up and remove the link
    if (link.parentNode) {
      link.parentNode.removeChild(link);
    }
    window.URL.revokeObjectURL(url);
  },

  upload: async (file: File): Promise<any> => {
    const formData = new FormData();
    formData.append("file", file);

    const response = await api.post("/vendors/upload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  },

  uploadVendors: async (file: File): Promise<any> => {
    return vendorService.upload(file);
  },

  downloadAll: async (): Promise<void> => {
    const response = await api.get("/vendors/download/all", {
      responseType: "blob",
    });

    // Create blob link to download
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;

    // Set filename with timestamp
    const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, '-');
    link.setAttribute('download', `vendors_export_${timestamp}.csv`);

    // Append to html link element page
    document.body.appendChild(link);

    // Start download
    link.click();

    // Clean up and remove the link
    if (link.parentNode) {
      link.parentNode.removeChild(link);
    }
    window.URL.revokeObjectURL(url);
  },

  // Keep the old method name for backward compatibility
  downloadAllVendors: async (): Promise<void> => {
    return vendorService.downloadAll();
  },
};
